import type { FC, PropsWithChildren } from 'react';
import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';

import { classes } from './SectionTitle.st.css';

type SectionTitleProps = {
  id?: string;
};

export const SectionTitle: FC<PropsWithChildren<SectionTitleProps>> = ({
  id,
  children,
}) => {
  return (
    <Text id={id} className={classes.root} tagName="h3">
      {children}
    </Text>
  );
};
